import Service from "../../AuthService";

const Order = {
    getOrder(page) {
        return Service.get("/order?page="+page);
    },
    allOrderOption(searchQuery) {
        return Service.get("/allOrderOption?where="+searchQuery);
    },
    showOrder(id) {
        return Service.get("/order/" + id);
    },
    checkOrder(id) {
        return Service.get("/check-order/" + id);
    },
    updateOrder(id, data) {
        return Service.put("/order/" + id, data);
    },
    createOrder(data) {
        return Service.post("/order", data);
    },
    deleteOrder(id) {
        return Service.delete("/order/" + id);
    },
    searchOrder(page,data) {
        return Service.post("search-order?page=" + page,data);
    },
    PromotionOrder(data){
        return Service.post("/order-promotion",data);
    },
    PromotionOrderMultiple(data){
        return Service.post("/order-promotion-multiple",data);
    },
    getOrderBefore(customer_id,transport_type_id){
        return Service.get("/get_order_before?customer_id="+customer_id+
            "&transport_type_id="+transport_type_id);
    },
    getProductByPromotionOther(sale_id){
        return Service.get("/get_promotion_other?sale_id="+sale_id);
    },
    changeStatusOrder(data){
        return Service.post("/change_status_order",data);
    },
    getOrderTransportPrice(data){
        return Service.post("/order_transport_price",data);
    },
    generateDO(){
        return Service.get('generate_do_number');
    },
    getNewPrice(id){
        return Service.get('get_new_price?id='+id);
    },
    orderProductForOpenInvoice(order_id){
        return Service.get('group_order_product?id='+order_id);
    },
    addNote(id){
        return Service.get('add_status_note?id='+id);
    }
};

export default Order;
